import * as AppConstants from 'app/AppConstants';
import groupBy from 'lodash/groupBy';
import keyBy from 'lodash/keyBy';

const initialState = () => ({
  dataSources: {},
  byCardId: {},
  filterGroups: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.CARD__LOAD_QUERYSTRING_PAGE_FILTERS_FINISHED:
    case AppConstants.CARD__LOAD_PAGE_FILTERS_FINISHED: {
      const keyedDataSources = keyBy(action.payload.dataSources, 'id');
      return {
        ...state,
        dataSources: {
          ...state.dataSources,
          ...keyedDataSources,
        },
      };
    }

    case AppConstants.DATASOURCE__LOADED_BY_CARD_ID: {
      const {dataSources, filterGroups, cardId} = action.payload;
      const keyedDataSources = keyBy(dataSources, 'id');
      const keyedFilterGroups = groupBy(filterGroups, 'dataSourceId');
      const dataSourceIds = Object.keys(keyedDataSources);
      return {
        ...state,
        dataSources: {
          ...state.dataSources,
          ...keyedDataSources,
        },
        byCardId: {
          ...state.byCardId,
          [cardId]: dataSourceIds,
        },
        filterGroups: {
          ...state.pdpFilterGroups,
          ...keyedFilterGroups,
        },
      };
    }

    default:
      return state;
  }
};
